import React from "react";
import Header from "../Header";
import Hero from "../Hero";

import "./index.css";

const index = () => {
  return (
    <div className="left-container">
      <Header />
      <Hero />
    </div>
  );
};

export default index;
